export const PROFILE_ENDPOINT = 'profile'
export const USER_ENDPOINT = 'user'

export type ApiScope = {
    uri: string
    scopes: string[]
}

export type ApiScopeMap = {
    [key:string]: ApiScope
}

export type MSALConfig = {
    clientId: string
    authority: string
    redirect: string
}

export type QSAppConfig = {
    url: string
    version: string
    buildVersion: string
}

export type Environment = {
    production: boolean
    useMocks: boolean
    apiBaseUrl: string
    qsapp: QSAppConfig
    msalConfig: MSALConfig
    apiScopes: ApiScopeMap
}

export function* allApiScopes(scopeMap: ApiScopeMap) : Generator<ApiScope> {
    for (const scopeName in scopeMap) {
        yield scopeMap[scopeName]
    }
}
